<template>
  <div class="layout sl-layout" :class="{'sl-layout-collapsed':isCollapsed , 'sl-layout-full':mapMode}">
    <Layout>
      <Header class="sl-header">
        <div class="sl-header-left">
          <div @click="home" :class="{'sl-header-logo':1,'textlogo':isTextLogo}">{{titleDisplay}}</div>
          <Menu class="sl-header-menu" mode="horizontal" theme="dark" :active-name="pageMode" @on-select="handleSelectMenu">
            <MenuItem name="manage">
              <Icon type="md-list-box" />
              管理模式
            </MenuItem>
            <MenuItem name="carmap">
              <Icon custom="i-icon icon-car"></Icon>
              车辆地图
            </MenuItem>
            <MenuItem name="companymap" v-if="isAS">
              <Icon custom="i-icon icon-company"></Icon>
              企业地图
            </MenuItem>
          </Menu>
        </div>
        <div class="sl-header-right">
          <div class="lo-collapse">
            <!-- <Icon @click.native="collapsedSider" :class="rotateIcon" type="md-menu" size="24"></Icon> -->
          </div>
          <div class="lo-top-menu">
            <Row type="flex" justify="space-between" align="middle" class="user-dropdown-innercon">
              <div class="lo-tooltip">
                <a v-if="isAdmin" @click="linkToMonitor">
                  <Icon size="24" type="ios-map-outline"></Icon>
                </a>
                <a>
                  <Poptip placement="top-end">
                    <Badge title="APP下载" :count="0" class-name="badge green" overflow-count="99">
                      <Icon size="24" type="ios-apps-outline"></Icon>
                    </Badge>
                    <div slot="content">
                      <sl-qrcode :content="appDownloadUrl" :width="200" :height="200"></sl-qrcode>
                    </div>
                  </Poptip>
                </a>
                <a>
                  <Message />
                </a>
              </div>
              <Dropdown transfer trigger="click" @on-click="handleDropdown">
                <div class="top-menu-header">
                  <!-- <Avatar :src="avatorPath" style="background: #619fe7;margin-left: 10px;"></Avatar> -->
                  <Icon class="menu-header-ic" size="18" type="ios-person"></Icon>
                  <span class="menu-header-name">{{ account }}</span>
                </div>
                <DropdownMenu slot="list">
                  <DropdownItem name="passwd">设置密码</DropdownItem>
                  <DropdownItem name="dev" v-if="isAdmin">开发设置</DropdownItem>
                  <DropdownItem name="profile" v-if="isCompany || isASS">我的企业</DropdownItem>
                  <DropdownItem name="signout" divided>退出登录</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </Row>
          </div>
        </div>
      </Header>
      <Layout>
        <Sider ref="sider" breakpoint="md" collapsible :collapsed-width="78" v-model="isCollapsed">
          <Aside :theme="theme" :menus="menus" :open-menus="openMenus" @change="menuChange"></Aside>
        </Sider>
        <Layout class="sl-content-fixed">
          <!-- <tag-view></tag-view> -->
          <div class="sl-content-wrap">
            <sl-breadcrumb :paths="paths" v-if="!mapMode"></sl-breadcrumb>
            <Content class="sl-content">
              <router-view></router-view>
              <!-- <sl-keep-alive :include="keepRoutes">
                <router-view></router-view>
              </sl-keep-alive> -->
            </Content>
          </div>
        </Layout>
      </Layout>
    </Layout>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Aside from './aside'
import SlBreadcrumb from './breadcrumb'
import TagView from './tagview'
import auth from '@/util/auth'
import router from '@/router'
import dev from '../debug/dev'
import global from '@/util/mixin/global'
import Message from './message'

export default {
  name: 'dashboard',
  mixins: [global],
  components: {
    Aside,
    SlBreadcrumb,
    TagView,
    Message
  },
  data() {
    return {
      isCollapsed: false,
      mapMode: false,
      mapType:'car',
      appDownloadUrl: location.origin + '/public/app/#/appDownload',
      state: {
        noticeCount: 0
      },
      lastRoute:null
    }
  },
  props: {

  },

  computed: {
    ...mapState({
      menus: state => state.auth.menu,
      account: state => state.auth.account,
      theme: state => state.theme,
      keepRoutes: state => state.tagview.visited.map(i => i.name),
      isCompany: state => state.auth.isCompany,
      isAdmin: state => state.auth.isAdmin,
      isASS: state => state.auth.isASS,
      isAS: state => state.auth.isAS
    }),
    //获取展开的菜单
    pageMode(){
      if( this.mapMode ){
        if( this.mapType == 'car') return 'carmap'
        else if( this.mapType == 'company') return 'companymap'
      }else{
        return 'manage'
      }
    },
    openMenus() {

      return (this.$route.matched || []).map(i => i.name)
    },

    paths() {
      return (this.$route.matched || []).filter(i => !!i.name).map(i => ({ icon: i.meta.icon, title: i.meta.title, path: i.path, name: i.name }))
    },

    titleDisplay() {
      if (this.userinfo && this.isSupervisor && this.userinfo.orgVO) {
        return this.userinfo.orgVO.name + '信息化管理平台'
      } else if(this.userinfo && this.isCompany) {
        return this.subject.companyName
      }else {
        return ''
      }
    },

    isTextLogo() {
      return this.userinfo && (this.isSupervisor || this.isCompany)
    },

    rotateIcon() {
      return [
        'menu-icon',
        this.isCollapsed ? 'rotate-icon' : ''
      ];
    },
    menuitemClasses() {
      return [
        'menu-item',
        this.isCollapsed ? 'collapsed-menu' : ''
      ]
    }
  },

  methods: {
    menuChange(name) {
      this.$router.setRoute(name)
    },
    handleSelectMenu(name){
      if( name == 'manage' ){
        if( this.lastRoute ){
          this.$router.push( this.lastRoute )
        }else{
          this.$router.setRouteByCode( this.isCompany ? 'setting.profile' : 'company.info')
        }
      }else if( name == 'carmap'){
        this.$router.replace({name:'dashboard.map.car'})
      }else if( name == 'companymap'){
        this.$router.replace({name:'dashboard.map.company'})
      }
    },

    handleDropdown(name) {
      if (name == 'signout') {
        this.$store.dispatch('auth/signout').then((res) => {
          //this.$router.reset()
          location.reload()
        })
      } else if (name == 'passwd') {
        this.$router.push({ name: 'setting.changePwd' })
      } else if (name == 'theme') {
        this.$store.dispatch('theme', 'ios')
      } else if (name == 'dev') {
        this.$dialog.show({ component: dev, width: 80, title: '接口设置' })
      } else if (name == 'profile') {
        this.$router.push({ name: 'setting.profile' })
      }
    },
    linkToMonitor() {
      // this.$router.push('/dashboard')
      this.$router.setRouteByCode('monitor', {}, true)
    },
    collapsedSider() {
      this.$refs.sider.toggleCollapse();
    },
    home() {
      if( this.isASS ){
        this.$router.push({ name:'setting.profile' })
      }else{
        this.$router.push('/')
      }
    }
  },

  created() {
    this.$watch('$route',function(to , from){
      if(to.meta && to.meta.mapMode === true){
        this.mapMode = true
        this.mapType = to.meta.type
        if(from && from.name && !from.name.toString().startsWith('dashboard.map')){
          console.log('save last route',from)
          this.lastRoute = from
        }
      }else{
        this.mapMode = false
      }

      if( to && to.name == 'dashboard'){
        if(from == undefined ){
          this.$router.replace({name:'dashboard.map.car'})
        }else {
          if( this.lastRoute && this.lastRoute.name != 'dashboard'){
            this.$router.replace(this.lastRoute)
          }else{
            let name = this.$router.getRouteByCode(this.isCompany ? 'setting.profile' : 'company.info')
            this.$router.replace({ name })
          }
        }
      }
/*      else if(this.isASS && to && to.name == 'dashboard'){
        this.$router.replace({ name:'setting.profile' })
      }*/
      // if( from && from.name == 'dashboard' && this.isSupervisor ){
      //   this.$router.setRouteByCode('company.info')
      // }
    },{immediate:true})
  },
  mounted() {

    const getChild = (target, type) => {
      while (true) {
        if (target.$refs && target.$refs[type]) {
          return target.$refs[type]
        } else if (target.$children.length) {
          target = target.$children[0]
        } else {
          return false
        }
      }

      return false
    }

    const getList = (target) => {
      while (true) {
        if (target['page'] && target['params']) {
          return target
        } else if (target.$children.length) {
          target = target.$children[0]
        } else {
          return false
        }
      }
      return false
    }


    document.addEventListener('paste', (e) => {

      let raw = e.clipboardData.getData('Text')
      let json
      try {
        json = JSON.parse(raw)
      } catch (e) {

      }


      if (this.$route.matched.length && json) {
        let component = this.$route.matched[this.$route.matched.length - 1]

        if (json.pageNum && json.search) {
          //{"search":{"name":null,"code":null,"contact":null,"contactPhone":null,"companyId":23,"deviceId":"10"},"pageSize":10,"pageNum":1}
          let instance = getList(component.instances.default)
          if (instance) {
            this.$utils.fill(instance.params, json.search)
            this.$utils.fill(instance.page, json)
          }
        } else {
          let instance = getChild(component.instances.default, 'item')
          if (instance && instance.form) {
            this.$utils.fill(instance.form, json)
          }
        }
      }
    })

    document.addEventListener('copy', (e) => {
      if (document.activeElement.tagName && ['INPUT', 'TEXTAREA'].includes(document.activeElement.tagName)) {
        return
      }
      let range = window.getSelection().getRangeAt(0)
      if (range.collapsed && this.$route.matched.length) {
        let component = this.$route.matched[this.$route.matched.length - 1]
        let instance

        instance = getChild(component.instances.default, 'item')

        if (instance && instance.form) {
          e.clipboardData.setData('text/plain', JSON.stringify(instance.form));
          e.preventDefault()
          return

        }

        instance = getList(component.instances.default)
        if (instance) {
          console.log(JSON.stringify({ pageSize: instance.page.pageSize, pageNum: instance.page.pagNum, search: instance.params }))
          e.clipboardData.setData('text/plain', JSON.stringify({ pageSize: instance.page.pageSize, pageNum: instance.page.pageNum, search: instance.params }))
          e.preventDefault()
          return
        }

      }
    })

    document.addEventListener('keydown', (event) => {
      var e = event || window.event || arguments.callee.caller.arguments[0];
      if (e && e.keyCode == 73 && e.ctrlKey) {
        let idcard = this.$utils.idCard()
        // this.$Notice.open({
        //   title: '身份证生成',
        //   desc: idcard
        // });

        if (document.activeElement) {
          let el = document.activeElement
          if (el.tagName == 'INPUT') {
            el.value = idcard
          }
        }
      }
    })
  }
}

</script>
